import { TAX_RATE } from "./constants";

export const calculateTax = (amount, rate = TAX_RATE) =>
  Math.ceil(amount * rate);
export const calculateItemSubtotal = (amount, quantity) => amount * quantity;
export const calculateTotal = (subtotal) => subtotal + calculateTax(subtotal);
